import { FIELD_VIEWERS } from '@wix/form-fields';
export const runAdditionalValidation = ({ form, values, externalData })=>{
    const additionalErrors = form.fields?.reduce((acc, field)=>{
        const fieldTarget = field.target;
        if (!fieldTarget) {
            return acc;
        }
        const fieldType = field?.view?.fieldType;
        const fieldValue = values[fieldTarget];
        const validateField = fieldType !== undefined ? FIELD_VIEWERS[fieldType]?.runAdditionalValidation : undefined;
        const error = validateField?.({
            value: fieldValue,
            target: fieldTarget,
            externalData
        });
        if (error) {
            acc[fieldTarget] = error;
        }
        return acc;
    }, {});
    return additionalErrors;
};

//# sourceMappingURL=additional-field-validation.js.map